import { render, staticRenderFns } from "./ActivityDescription.vue?vue&type=template&id=5342783c&scoped=true"
import script from "./ActivityDescription.vue?vue&type=script&lang=js"
export * from "./ActivityDescription.vue?vue&type=script&lang=js"
import style0 from "./ActivityDescription.vue?vue&type=style&index=0&id=5342783c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5342783c",
  null
  
)

export default component.exports